import * as Rox from "rox-browser";

export const special_invoices = {
    dashboard: new Rox.Flag(),
    financial_documents__calendar: new Rox.Flag(),
    credit_request: new Rox.Flag(),
    reports: new Rox.Flag(),
    billing_issues__filter_category: new Rox.Flag()
};
